import { BasicCrudService } from '@/app/common/utils/crud/basic-crud.service';
import { Injectable } from '@angular/core';
import { CompanyApiService } from '../infra/api.service';
import { Company, CompanyFindAllParams, CompanyCreateParams } from './type';
import { User } from '../../user/core/type';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root', useClass: CompanyApiService })
export abstract class CompanyService extends BasicCrudService<
  Company,
  Company['id'],
  CompanyFindAllParams,
  Company,
  CompanyCreateParams
> {}
